/*
 * Copyright (c) Funtip GbR 2018.
 * Simon Oldeboershuis, Perry Prust
 */

import { GlobalState } from '../actions';
import { ACCESS_TOKEN_KEY } from './systemConfig';

export const systemState = (state: GlobalState) => state.system;

export const systemAccessTokenSelector = (state: GlobalState) => systemState(state).accessToken;

export const globalStateSelector = (state: GlobalState) => state;

export const clientTagSelector = (state: GlobalState) => systemState(state).clientTag;

export const isLoggedInSelector = (state: GlobalState) => {
    const stateAccessToken = systemAccessTokenSelector(state);
    const storageAccessToken = localStorage.getItem(ACCESS_TOKEN_KEY);
    return (
        (!!stateAccessToken && stateAccessToken !== '') ||
        (!!storageAccessToken && storageAccessToken !== '')
    );
};

export const isSysAdminSelector = (state: GlobalState) => systemState(state).userRoles.indexOf('sysadmin') !== -1;

export const isForumAdminSelector = (state: GlobalState) => systemState(state).userRoles.indexOf('forumAdmin') !== -1;

export const isClientAdminSelector = (state: GlobalState) => systemState(state).userRoles.indexOf('clientadmin') !== -1;

export const systemUserRolesSelector = (state: GlobalState) => systemState(state).userRoles;

export const systemPopupMessageSelector = (state: GlobalState) => systemState(state).popupMessage;

export const isPlaylistAdminSelector = (state: GlobalState) =>
    systemState(state).userRoles.indexOf('playlistAdmin') !== -1;

export const userInfoSelector = (state: GlobalState) => systemState(state).userInfo;

export const userNameSelector = (state: GlobalState) => {
    const ui = systemState(state).userInfo;
    return ui ? ui.name : undefined;
};

export const userIdSelector = (state: GlobalState) => {
    const ui = systemState(state).userInfo;
    return ui ? ui.id : undefined;
};

export const errorMessageSelector = (state: GlobalState) => systemState(state).errors;

export const showErrorsSelector = (state: GlobalState) => systemState(state).showErrors;

export const systemPrivacyStatementVersionSelector = (state: GlobalState) =>
    systemState(state).agbInfos.privacyStatementVersion;

export const systemPrivacyStatementUrlSelector = (state: GlobalState) =>
    systemState(state).agbInfos.privacyStatementUrl;

export const systemConfirmedPrivacyStatementVersionSelector = (state: GlobalState) =>
    systemState(state).agbInfos.confirmedPrivacyStatementVersion;

export const systemPrivacyStatementSelector = (state: GlobalState) => systemState(state).agbInfos.privacyStatement;

export const systemImprintStatementSelector = (state: GlobalState) => systemState(state).agbInfos.imprint;

export const systemServerAvailabilitySelector = (state: GlobalState) => systemState(state).serverAvailability;

export const systemNavLocation = (state: GlobalState) => systemState(state).navLocation;

export const systemIsFetchingSelector = (state: GlobalState) => systemState(state).isFetching;

export const systemDeploymentPropertiesDeleteTokenUrl = (state: GlobalState) => {
    const dp = systemState(state).deploymentProperties;
    if (dp) {
        return dp.deleteTokenUrl;
    } else {
        return undefined;
    }
};

export const systemShowLogoutConfirmationSelector = (state: GlobalState) => systemState(state).showLogoutConfirmation;

export const systemShowAutomaticLogoutMessageSelector = (state: GlobalState) =>
    systemState(state).showAutomaticLogoutMessage;

export const systemIsLoginRequiredSelector = (state: GlobalState) => systemState(state).loginRequired;
export const systemLoginNextUrlSelector = (state: GlobalState) => systemState(state).loginNextUrl;

export const systemPushSubscriptionSelector = (state: GlobalState) => systemState(state).pushSubscription;
export const systemPushSubscriptionPublicKeySelector = (state: GlobalState) =>
    systemState(state).pushSubscriptionPublicKey;
